import { connect } from "react-redux";
import { ApplicationState } from "store";
import { actionCreators, getCalendar } from "page/calendar/store";
import ThemeGallery from "./theme-gallery";
import { actionCreators as uiActionCreators } from "ui/store";

const mapStateToProps = (state: ApplicationState) => ({
    calendar: getCalendar(state),
});

const mapDispatchToProps = {
    setActiveCalendar: actionCreators.setActiveCalendar,
    ...uiActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeGallery);
